import { layout, moduleRoute } from '@src/helper/routes'
import type { Router } from 'vue-router'

export default (router: Router) => {
    router.addRoute(
        layout(
            'Login',
            'StaticForms',
            [
                moduleRoute(
                    'HumanResources',
                    'CandidateProfile',
                    '/humanResources/candidateForm/:token'
                ),
                moduleRoute(
                    'HumanResources',
                    'JobPositionForm',
                    '/humanResources/apply/job/:id'
                ),
                moduleRoute(
                    'HumanResources',
                    'JobPositionApplied',
                    '/humanResources/applied'
                ),
                moduleRoute(
                    'HumanResources',
                    'ExternalFormApplication',
                    '/humanResources/externalForm/:id'
                ),
            ],
            '/humanResources'
        )
    )
}
